/**
 * The four different orientation settings.
 */
export enum DeviceOrientation {
    portrait = 'portrait',
    landscape90 = 'landscape90',
    landscape270 = 'landscape270',
    portrait180 = 'portrait180',
}
